/* Libraries */
import cn from 'classnames';

/* App Store: mobile */
import { useMobileStoreActions } from '@store/client/store.mobile';

/* Styles */
import styles from './darkoverlay.module.scss';

/* Types Inline */
type DarkOverlayProps = {
  isOpen: boolean;
};

const DarkOverlay = ({ isOpen }: DarkOverlayProps) => {
  /* Store Action */
  const { updateToggleSidebar } = useMobileStoreActions();

  /* Context */
  const darkOverlayStyles = cn(styles.overlay, {
    [styles.open]: isOpen,
  });

  return <div className={darkOverlayStyles} onClick={() => updateToggleSidebar()} />;
};

export default DarkOverlay;
